import { render } from "./invertorInstitution.vue?vue&type=template&id=7c2c7a10&scoped=true"
import script from "./invertorInstitution.vue?vue&type=script&lang=js"
export * from "./invertorInstitution.vue?vue&type=script&lang=js"

import "./invertorInstitution.vue?vue&type=style&index=0&id=7c2c7a10&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2c7a10"]])

export default __exports__